import {useFicha21} from '../../../../context/UserModulesContext';
import {AccessService} from '../../../../utils/AccessService';

/**
 * ¿La bandeja de Hechos está bloqueada por el plan? Sí sólo con la Memoria del Cliente en OFF.
 *
 * En OFF el acto Memoria existe igual —sobrevive por la Bitácora (`boosterStepsFor`)—, pero no hay
 * acto Alimenta: el vacío de Hechos ofrecía «Cargar material», un link a `#alimenta`, que no se
 * dibuja, y el clic no hacía nada (punto 18 del recorrido de la 2.1, agencia en free trial). Con
 * MEDIO y TOTAL el vacío queda como estaba.
 *
 * Antes de `loaded` el nivel es el default del contexto (OFF): bloquear ahí sería mostrar el
 * candado un instante a una agencia que tiene la Memoria.
 */
export function factsLayerLocked({clientMemoryLevel, loaded}) {
    return loaded === true && clientMemoryLevel === AccessService.MEMORY_LEVEL_OFF;
}

export function useFactsLayerLocked() {
    const {clientMemoryLevel, loaded} = useFicha21();
    return factsLayerLocked({clientMemoryLevel, loaded});
}
